import { render, staticRenderFns } from "./TimerProductRecommendation.vue?vue&type=template&id=3f4557fa&scoped=true"
import script from "./TimerProductRecommendation.vue?vue&type=script&lang=js"
export * from "./TimerProductRecommendation.vue?vue&type=script&lang=js"
import style0 from "./TimerProductRecommendation.vue?vue&type=style&index=0&id=3f4557fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4557fa",
  null
  
)

export default component.exports